function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.48839 5.08539C8.22615 5.1728 6.4123 8.14488 2.58795 9.78389C1.60455 10.3302 1.16748 11.3136 1.38603 14.3731C1.55731 16.7709 4.1177 17.5418 4.55477 17.5418C4.90443 17.5418 20.6535 17.3962 28.4843 17.3233C29.1763 17.3597 30.2107 16.7551 30.5603 16.2306C31.2159 15.2472 31.3252 14.0453 31.1067 12.7341C30.9318 11.6851 29.4312 10.4395 28.7028 10.2209C25.534 9.67461 24.8784 9.78388 24.1136 9.12828C23.175 8.32375 19.3303 5.22809 18.7595 5.08539C17.8853 4.86687 8.81619 4.97612 8.48839 5.08539ZM8.48839 5.08539C7.61425 4.50263 5.66928 3.22786 4.88256 2.79079C3.89916 2.24446 2.91575 0.823988 1.16748 1.91666",
  stroke: "white",
  strokeWidth: 1.09267,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2195 6.94321L9.25269 10.112H14.1697",
  stroke: "white",
  strokeWidth: 1.09267,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 16.4641,
  y: 11.7509,
  width: 3.05948,
  height: 0.655602,
  rx: 0.327801,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.17653,
  cy: 16.8861,
  r: 2.95021,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.1294,
  cy: 16.8861,
  r: 2.95021,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.17642,
  cy: 16.8864,
  r: 2.07607,
  fill: "#373D49"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.1298,
  cy: 16.8864,
  r: 2.07607,
  fill: "#373D49"
});

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.ca502ca8.svg";
export { ForwardRef as ReactComponent };